import BookLibraryAdapter from 'teacher-ui-client/adapters/book-library'

export default class CollectionStatAdapter extends BookLibraryAdapter {}
